module.exports = __webpack_public_path__ + "media/images/product_lines/car/main-1339f107cee61d64aab1c56dc2dbf509.svg";